import { forwardRef } from 'react'
import PropTypes from 'prop-types'

const Textarea = forwardRef(({ wrapperClassName, className, ...props }, ref) => {
  return (
    <div className={`${wrapperClassName} relative`}>
      <textarea
        className={`placeholder:text-[#F6744388] border !border-primary-450 rounded-lg block py-[10px] px-[14px] ${className} outline-none w-full`}
        ref={ref}
        {...props}
      ></textarea>
    </div>
  )
})

Textarea.defaultProps = {
  wrapperClassName: '',
  className: '',
}
Textarea.propTypes = {
  wrapperClassName: PropTypes.string,
  className: PropTypes.string,
}
export default Textarea
